// The words of Simple's greeting and its start card (spec ui-perf/simple-home, "Home"), and the
// brand's colour for its name (spec ui-perf/simple-flows).
import type { Brand } from "../../../api/generated/model";
import { contrast, parseColor } from "../../../platform/themes/color";

/** The first word of a person's name, the prototype's "Hi Logan"; none for no name. */
export function firstName(name: string | null | undefined): string | undefined {
  const first = name?.trim().split(/\s+/)[0];
  return first === undefined || first === "" ? undefined : first;
}

/** A product's name with its brand's name taken off its front, as the prototype's start card. */
export function withoutBrand(product: string, brand: string): string {
  const name = product.trim();
  const prefix = `${brand.trim()} `.toLowerCase();
  if (prefix.trim() !== "" && name.toLowerCase().startsWith(prefix)) {
    const rest = name.slice(prefix.length).trim();
    if (rest !== "") return rest;
  }
  return name;
}

/** The brand's own colour for its name: its Primary, else its first, else none. */
export function brandColor(brand: Brand | undefined): string | undefined {
  const colors = brand?.colors ?? [];
  return (colors.find((color) => color.label?.toLowerCase() === "primary") ?? colors[0])?.hex;
}

/** Large text's WCAG AA: 3:1 against what is under it. Unknown is no. */
export function readsOn(color: string, background: string | undefined): boolean {
  if (background === undefined) return false;
  try {
    return contrast(color, background) >= 3;
  } catch {
    return false;
  }
}

/** The first opaque background behind an element (the page's panel), as the browser draws it. */
export function backgroundBehind(element: Element | null): string | undefined {
  for (let at = element; at !== null; at = at.parentElement) {
    const value = getComputedStyle(at).backgroundColor;
    try {
      if (parseColor(value)[3] >= 1) return value;
    } catch {
      // "" or a keyword the parser does not read: look further out.
    }
  }
  return undefined;
}
